<div class="tags applied">
  <div class="tags-container">
    @for (tag of tags(); track tag.id) {
      <div
        class="tag {{ tag.color }}"
        [class.no-color]="!tag.color"
        [class.dark]="tag.color"
        (click)="editTag($any(tag))"
        [appTooltip]="canEditTag() ? 'Edit tag' : undefined"
      >
        <app-svg src="/assets/icons/tag-filled.svg" size="-1" class="tag-icon"></app-svg>
        <div>{{ tag['name'] }}</div>
        <button
          appButton
          name="remove"
          location="asset-tags"
          [iconButton]="true"
          shape="round"
          [color]="tag.color ? 'hard-simple' : 'simple-gray-50'"
          height="-2"
          appTooltip="Remove tag"
          (click)="removeTagFromAsset($any(tag), $event)"
        >
          <app-svg src="/assets/icons/cross.svg"></app-svg>
        </button>
      </div>
    }
    @if (!tagTypeahead._isOpen()) {
      <div class="tag add-tag" data-test-id="add-tag" (click)="tagTypeahead.open()">
        <app-svg src="/assets/icons/plus.svg" size="0"></app-svg>
        <div>Add</div>
      </div>
    }
  </div>
  <app-context-menu
    [options]="{ width: '320px', noSpacing: true }"
    verticalPosition="top"
    position="screen-right"
    #tagTypeahead
  >
    <div contextContent>
      @if (allAvailableTags().length) {
        <div class="tags selection">
          @if (!filteredTags().length) {
            <div class="empty-tags">No tags found</div>
          }
          @if (filteredTags().length) {
            <div class="tags-container selection">
              @for (tag of filteredTags(); track tag.id) {
                <div
                  class="tag light no-hover {{ tag.color }}"
                  [class.dark]="tag.color"
                  [class.no-color]="!tag.color"
                  (click)="addTagToAsset(tag)"
                >
                  <app-svg src="/assets/icons/tag-filled.svg" size="-1" class="tag-icon"></app-svg>
                  <div>{{ tag.name }}</div>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (addTagForm.value.name && canCreate()) {
        <div class="divider"></div>
        <button
          appButton
          name="create"
          location="asset-tags"
          class="create-tag"
          data-test-id="create-tag"
          [hasIcon]="true"
          (click)="addTag()"
          color="simple"
          height="1"
          spacing="1"
        >
          <app-svg src="/assets/icons/plus.svg"></app-svg>
          <span>Create “{{ addTagForm.value.name }}”</span>
        </button>
      }
    </div>
  </app-context-menu>
  @if (tagTypeahead._isOpen()) {
    <form [formGroup]="addTagForm" (ngSubmit)="addTag()">
      <input
        type="text"
        formControlName="name"
        enterkeyhint="next"
        data-test-id="add-tag-input"
        #input
        placeholder="Add a tag..."
        (click)="isFocused(input, $event) || tagTypeahead.open()"
        autocomplete="off"
        data-1p-ignore="true"
        data-lpignore="true"
        appAutofocus
      />
    </form>
  }
</div>
